import { init, type We0Client } from "we0-analyze-sdk";

let client: We0Client | undefined;

// 初始化埋点
export function initWe0Analyze(): We0Client | undefined {
	if (client || typeof window === "undefined" || typeof document === "undefined") {
		return client;
	}

	const projectId = process.env.PROJECT_ID;
	if (!projectId) {
		return undefined;
	}

	client = init({
		projectId,
		autoTrackPageview: true,
		endpoint: "/api/we0-analyze/events",
	});
	return client;
}
